import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import ApFooter from "./shared/base/ApFooter";
import { ToastContainer } from "react-toastify";
import { Route, Routes } from "react-router-dom";
import {
  AUTHENTICATED_ROUTES,
  UNAUTHENTICATED_ROUTES,
} from "./shared/constants/routes";
import { Suspense, useContext } from "react";
import ProgressLoader from "./shared/components/ProgressLoader";
import ApAppbar from "./shared/base/ApAppBar";
import { makeStyles } from "@material-ui/core/styles";
import UserContextProvider from "./shared/store/UserContextProvider";
import VerifyRoute from "./shared/components/RouteVerifier";
import AppConfigProvider from "./shared/store/AppConfigProvider";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { ThemeContext } from "./shared/store/ThemeContextProvider";

const useStyles: any = makeStyles(() => ({
  appContainer: {
    minHeight: "calc(100vh - 101px)",
    "& h1": {
      margin: 0,
    },
    "& h6": {
      margin: 0,
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const App = () => {
  const { theme } = useContext(ThemeContext);
  const classes = useStyles();
  return (
    <MuiThemeProvider theme={theme}>
      <BrowserRouter>
        <ToastContainer autoClose={5000} limit={5} />
        <UserContextProvider>
          <AppConfigProvider>
            <ApAppbar />
            <div className={classes.appContainer}>
              <Routes>
                {UNAUTHENTICATED_ROUTES.map(({ url, component }, index) => (
                  <Route
                    path={url}
                    element={
                      <Suspense fallback={<ProgressLoader isOpen />}>
                        {component}
                      </Suspense>
                    }
                    key={`unAuthenticatedRoutes-${index}`}
                  />
                ))}
                <Route
                  path="/"
                  element={
                    <div className="App">
                      <header className="App-header">
                        <img src={logo} className="App-logo" alt="logo" />
                      </header>
                    </div>
                  }
                  key={`home`}
                />
                {AUTHENTICATED_ROUTES.map(
                  ({ url, component, displaySidebar }, index) => (
                    <Route
                      path={url}
                      element={
                        <Suspense fallback={<ProgressLoader isOpen />}>
                          <VerifyRoute displaySidebar={displaySidebar}>
                            {component}
                          </VerifyRoute>
                        </Suspense>
                      }
                      key={`authenticatedRoutes-${index}`}
                    />
                  )
                )}
              </Routes>
            </div>
            <ApFooter />
          </AppConfigProvider>
        </UserContextProvider>
      </BrowserRouter>
    </MuiThemeProvider>
  );
};

export default App;
